<template>
<div class="chapter">
<div class="inner_page">
<p class="image"><img alt="images" src="images/f016-01.jpg" width="80%"/></p>
<p class="caption"><em class="italic">The iconic image depicting the pointing finger of Lord Kitchener which originally appeared on the front cover of</em> London Opinion <em class="italic">magazine in early September 1914. Subsequently modified on later posters it encouraged British men to flock to the recruiting offices</em>.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 24_fm037.vue?6f5ee5f9